(() => {
 const init = (root = document) => {
  root.querySelectorAll('[data-member-ranks]').forEach((set) => {
   if (set.dataset.ready) return;
   const buttons = [...set.querySelectorAll('[data-member-rank-button]')];
   const panels = [...set.querySelectorAll('[data-member-rank-panel]')];
   if (!buttons.length || buttons.length !== panels.length) return;
   const choose = (selected) => {
    buttons.forEach((button) => {
     const active = button === selected;
     button.classList.toggle('is-selected', active);
     button.setAttribute('aria-pressed', String(active));
    });
    panels.forEach((panel) => panel.classList.toggle('is-selected', panel.dataset.memberRankPanel === selected.dataset.memberRankButton));
   };
   buttons.forEach((button, index) => {
    button.addEventListener('click', () => choose(button));
    button.addEventListener('keydown', (event) => {
     let target;
     if (event.key === 'ArrowRight') target = (index + 1) % buttons.length;
     if (event.key === 'ArrowLeft') target = (index - 1 + buttons.length) % buttons.length;
     if (event.key === 'Home') target = 0;
     if (event.key === 'End') target = buttons.length - 1;
     if (target === undefined) return;
     event.preventDefault();
     buttons[target].focus();
     choose(buttons[target]);
    });
   });
   set.classList.add('is-ready');
   set.dataset.ready = 'true';
  });
  root.querySelectorAll('[data-member-carousel]').forEach((carousel) => {
   if (carousel.dataset.ready) return;
   const track = carousel.querySelector('[data-member-carousel-track]');
   const previous = carousel.querySelector('[data-member-carousel-previous]');
   const next = carousel.querySelector('[data-member-carousel-next]');
   if (!track || !previous || !next) return;
   const update = () => {
    previous.disabled = track.scrollLeft < 3;
    next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 3;
   };
   const move = (direction) => {
    const card = track.querySelector('a');
    const distance = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap) : track.clientWidth;
    track.scrollBy({left: distance * direction, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
   };
   previous.addEventListener('click', () => move(-1));
   next.addEventListener('click', () => move(1));
   track.addEventListener('scroll', update, {passive:true});
   track.addEventListener('keydown', (event) => {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    event.preventDefault();
    move(event.key === 'ArrowLeft' ? -1 : 1);
   });
   new ResizeObserver(update).observe(track);
   update();
   carousel.dataset.ready = 'true';
  });
 };
 init();
 document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
